import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import FieldSection from 'components/forms/FieldSection';
import MobilePhoneSection from 'components/forms/contact-information/MobilePhoneSection';
import SmsSection from 'components/forms/contact-information/SmsSection';
import * as signUpSelectors from 'state/selectors/signUpSelectors';
import { I18N, GlobalContext } from 'commons';
import Header from './Header';

const ContactInformationSection = ({
  values,
  touched,
  errors,
  setFieldValue,
  setFieldError,
  setFieldTouched,
  phoneInfo,
  smsValidate,
  phoneValidate,
  showMiniRequiredContactPathError,
  minContactPath,
  isAllFieldMandatory,
  setIscallOutMsgShow,
  isEnableCountryCodeForMemberPortal,
  countries,
  selectedCountries,
  hasUnsupportedCountrycode,
  setHasUnsupportedCountrycode
}) => {
  const {
    organization: { signupEmailEditable, signupEmailMandatory, SMSSetting = {}, phoneSetting = {}, slackSetting = {} },
  } = useContext(GlobalContext);
  const emailMandatory = isAllFieldMandatory || signupEmailMandatory;
  // sms config
  const smsPathId = SMSSetting.pathId;
  const SMSMandatory = isAllFieldMandatory || SMSSetting.mandatory;
  const SMSEditable = SMSSetting.editable;
  const SMSExposed = SMSSetting.exposed;
  const SMSPrompt = SMSSetting.prompt;
  // phone config
  const phonePathId = phoneSetting.pathId;
  const phoneMandatory = isAllFieldMandatory || phoneSetting.mandatory;
  const phoneEditable = phoneSetting.editable;
  const phoneExposed = phoneSetting.exposed;
  const phonePrompt = phoneSetting.prompt;
  // slack config
  const slackExposed = slackSetting.exposed;
  const slackEditable = slackSetting.editable;
  const slackPrompt = slackSetting.prompt;
  const slackMandatory = slackSetting.mandatory;
  const slackType = slackSetting.type;

  const parentMandatory = Boolean(emailMandatory || SMSMandatory || phoneMandatory || slackMandatory);

  return (
    <div className="col-md-12">
      <Header
        mandatory={parentMandatory}
        minRequired={minContactPath}
        isAllFieldMandatory={isAllFieldMandatory}
      />
      {
        showMiniRequiredContactPathError &&
        <div className="col-md-10 pl-0">
          <label
            id="minContactPath-error"
            className="text-danger"
            htmlFor="minContactPath"
          >
            <I18N>
              {`new.registration.signup.create.contactpath.error, ${minContactPath}`}
            </I18N>
          </label>
        </div>
      }
      <div className="form-group row">
        <FieldSection
          className="col-md-8"
          name="email"
          type="email"
          title="new.registration.signup.create.account.label.emailAddress"
          isOptional={!emailMandatory}
          maxLength="80"
          minLength="6"
          isDisable={!signupEmailEditable}
          autoComplete="email"
          {...{ values, touched, errors }}
        />
      </div>
      <div className="form-group row">
        {SMSExposed && (
          <SmsSection
            {...{
              SMSEditable,
              SMSMandatory,
              smsPathId,
              SMSPrompt,
              smsValidate,
              setIscallOutMsgShow,
              isEnableCountryCodeForMemberPortal,
              countries,
              selectedCountries,
              hasUnsupportedCountrycode,
              setHasUnsupportedCountrycode
            }}
            {...{values, touched, errors, setFieldValue, setFieldError, setFieldTouched}}
          />
        )}
        {phoneExposed && (
          <MobilePhoneSection
            {...{
              phoneEditable,
              phoneMandatory,
              phonePathId,
              phonePrompt,
              phoneValidate,
              isEnableCountryCodeForMemberPortal,
              countries,
              selectedCountries,
              hasUnsupportedCountrycode,
              setHasUnsupportedCountrycode
            }}
            {...{ values, touched, errors, setFieldValue, setFieldError, setFieldTouched }}
          />
        )}

        {slackExposed && (
          <FieldSection
            className="col-md-8"
            name="slack"
            type="email"
            title={slackPrompt}
            isOptional={!slackMandatory}
            maxLength="80"
            minLength="6"
            isDisable={!slackEditable}
            {...{ values, touched, errors }}
          />
        )}
      </div>
    </div>
  );
};

ContactInformationSection.propTypes = {
  values: PropTypes.shape().isRequired,
  touched: PropTypes.shape().isRequired,
  errors: PropTypes.shape().isRequired,
  setFieldValue: PropTypes.func.isRequired,
  setFieldError: PropTypes.func.isRequired,
  setFieldTouched: PropTypes.func.isRequired,
  minContactPath: PropTypes.number.isRequired,
  isAllFieldMandatory: PropTypes.bool.isRequired,
  setIscallOutMsgShow: PropTypes.func.isRequired,
  isEnableCountryCodeForMemberPortal: PropTypes.bool.isRequired,
  countries: PropTypes.arrayOf(PropTypes.array).isRequired,
  selectedCountries: PropTypes.arrayOf(PropTypes.array).isRequired,
  hasUnsupportedCountrycode: PropTypes.shape().isRequired,
  setHasUnsupportedCountrycode: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  emailInfo: signUpSelectors.selectSignPublicProfileInfoEmailInfo(state),
  phoneInfo: signUpSelectors.selectSignPublicProfileInfoPhoneInfo(state),
  phoneValidate: signUpSelectors.selectSignPhoneValidate(state),
  SMSInfo: signUpSelectors.selectSignPrivateUserInfoSMSInfo(state),
  smsValidate: signUpSelectors.selectSignSmsValidate(state),
  slackInfo: signUpSelectors.selectSignPrivateUserInfoSMSInfo(state),
});

export default connect(mapStateToProps)(ContactInformationSection);
